module.exports = __webpack_public_path__ + "static/media/026-chat.650913a6.svg";